
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Anklage wegen sexueller Belästigung</h4>
    <p>
  Innert zwei Tagen soll William W. gemäss Anklageschrift zwei Mädchen im Haus des «Palacio de la Paz» sexuell
  missbraucht haben. Ein mutmassliches Opfer habe er gebeten, Unterlagen für ihn zu kopieren. Als die 13-Jährige dies
  erledigen wollte, habe er ihr gesagt, sie sei hübsch und gefragt, ob er sie küssen könne. Das Opfer habe verneint.
  Trotzdem versucht es W. gemäss Staatsanwaltschaft zweimal, was die Teenagerin abgewehrt habe. Am Tag darauf zeigt der
  Beschuldigte laut Anklage einer ebenfalls 13-Jährigen die Räumlichkeiten seines Restaurants und versetzt ihr dabei auf
  der Kellertreppe einen Klaps auf den Po. Auch diese Vorwürfe, die von W. bestritten werden, sind vom Gericht noch zu
  beurteilen.
  <Image source='Ehemaliges Restaurant von W. (Google Streetview)' file={require('images/streetview.jpg')} mdxType="Image" />
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;